/**
 * 현장 알림 받기(TS_SITE_ASSIGN.NOTI_RECEIVE_YN) 아이콘 — 추출기획서 20261015 E-0 · E-2.
 *  - 받음: 종(브랜드색 = groupTheme primary — MultiSelect 칩 토글의 켜짐 색과 같음) / 안 받음: 사선 그은 종(회색)
 *  - 담당자 고정: 자물쇠 달린 종(무채색) — 누를 수 없음을 켬/끔 토글과 구분한다
 * 색은 currentColor — 쓰는 쪽이 토큰 클래스로 정한다.
 * 편집 모드의 칩 안 켬/끔 토글은 ui-core MultiSelect toggled(AssigneeSelect notiIds)가 그린다.
 */
const BELL_PATH = 'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9';
const CLAPPER_PATH = 'M13.73 21a2 2 0 0 1-3.46 0';

type IconProps = { size?: number; className?: string };

export function BellIcon({ size = 14, className = '' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d={BELL_PATH} /><path d={CLAPPER_PATH} />
    </svg>
  );
}

export function BellOffIcon({ size = 14, className = '' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M13.73 21a2 2 0 0 1-3.46 0" /><path d="M18.63 13A17.89 17.89 0 0 1 18 8" />
      <path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14" /><path d="M18 8a6 6 0 0 0-9.33-5" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
}

/** 자물쇠 달린 종 — 현장 담당자는 알림을 항상 받음(끌 수 없음) */
export function BellLockIcon({ size = 14, className = '' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M15 17H3s3-2 3-9a6 6 0 0 1 11.6-2.1" /><path d="M10.27 21a2 2 0 0 0 3.46 0" />
      <rect x="15" y="13" width="7" height="6" rx="1" fill="currentColor" />
      <path d="M16.5 13v-1.5a2 2 0 0 1 4 0V13" />
    </svg>
  );
}

/** 담당자 고정 표시 — 조작 없음. 칩·이름 옆에 쓴다 */
export function ChargeNotiMark({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex shrink-0 text-text-muted ${className}`} role="img" aria-label="알림 항상 받음">
      <BellLockIcon />
    </span>
  );
}

/** 관리자 알림 받음/안 받음 표시(보기 모드) — 조작 없음 */
export function NotiStateMark({ on, className = '' }: { on: boolean; className?: string }) {
  return (
    <span className={`inline-flex shrink-0 ${on ? 'text-group' : 'text-text-disabled'} ${className}`}
      role="img" aria-label={on ? '알림 받음' : '알림 안 받음'}>
      {on ? <BellIcon /> : <BellOffIcon />}
    </span>
  );
}
